import { Injectable } from '@angular/core';
import { createEffect, ofType, Actions } from '@ngrx/effects';
import { switchMap, tap } from 'rxjs/operators';
import { of } from 'rxjs';
import { IdentifyService } from 'src/app/service/http/identify/identify.service';
import { IIdentify } from 'src/app/models/identify.interface';
import { GetIdentify, EIdentifyActions, GetIdentifySuccess } from '../actions/identify.actions';


@Injectable()
export class IdentifyEffects {
  
  getIdentify$ = createEffect(() => this._actions$.pipe(
    ofType<GetIdentify>(EIdentifyActions.GetIdentify),
    switchMap(() => this._identifyService.getIdentify()),
    switchMap((identify: IIdentify) => {
      return of(new GetIdentifySuccess(identify));
    })
  ));

  constructor(
    private _identifyService: IdentifyService,
    private _actions$: Actions) {}
}
